module.exports = __webpack_public_path__ + "static/media/login-banner.1f046a19.jpg";